/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import { Divider } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import 'typeface-roboto';
import axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import LinearProgress from '@material-ui/core/LinearProgress';
import _ from 'lodash';
import NumberFormat from 'react-number-format';

let isDlgLacakMounted = false;

const useStyles = makeStyles({
  cardWrapper: {
    marginBottom: 5,
  },
  dialogContentStyle: {
    minHeight: 350,
    maxHeight: 350,
    scrollbarWidth: 0,
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      width: '0px',
      background: 'transparent',
    },
  },
  titleStyle: {
    textAlign: 'center',
  },
});

const DialogLacakResi = (props) => {
  const classes = useStyles();
  const [manifests, setManifests] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const {
    courierCode, shippingCode, open, onClose,
  } = props;

  useEffect(() => { // dijalankan saat open = true
    if (open) {
      if (isDlgLacakMounted) {
        setLoading(true);
        axios.post(`https://eqiozmart.com/location/lacak/${courierCode}/${shippingCode}/`, {
          courier: courierCode,
          waybill: shippingCode,
        }).then((response) => {
          if (_.isArray(response.data.manifests)) {
            if (isDlgLacakMounted) {
              setManifests(response.data.manifests);
              setLoading(false);
            }
          }
        });
      }
    }
  }, [open, courierCode, shippingCode]);

  useEffect(() => () => { // component unmount
    isDlgLacakMounted = false;
  }, []);

  useEffect(() => () => { // component mount
    isDlgLacakMounted = true;
  });

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog maxWidth="xs" fullWidth onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle className={classes.titleStyle} id="simple-dialog-title">Lacak Resi</DialogTitle>
      <DialogContent className={classes.dialogContentStyle}>
        <LinearProgress style={loading ? {} : { display: 'none' }} />
        <Stepper activeStep={0} orientation="vertical">
          {manifests.map((step, index) => (
            <Step key={index} expanded>
              <StepLabel icon={_.size(manifests) - index}>
                {step.manifest_date}
                {' '}
                {step.manifest_time}
              </StepLabel>
              <StepContent>
                <Typography>{step.city_name}</Typography>
                <Typography>{step.manifest_description}</Typography>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="outlined">
          TUTUP
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const OrderInformasiKurir = (props) => {
  const classes = useStyles();
  const { data } = props;
  const [openLacak, setOpenLacak] = React.useState(false);

  const handleOpenLacak = () => {
    if (!_.isEmpty(data.order_shipping_code)) {
      setOpenLacak(true);
    }
  };

  const handleOnLacakClose = () => {
    setOpenLacak(false);
  };

  return (
    <Card className={classes.cardWrapper}>
      <CardHeader
        title="Informasi Kurir"
        subheader="Informasi detail kurir pengiriman"
      />
      <CardActionArea onClick={handleOpenLacak}>
        <CardContent>
          <Grid container spacing={2} justify="space-between">
            <Grid item>
              <Typography className={classes.label} variant="button">KURIR</Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.label} variant="button">{data.order_courier_name}</Typography>
            </Grid>
          </Grid>
          <Divider />
          <Grid container spacing={2} justify="space-between">
            <Grid item>
              <Typography className={classes.label} variant="button">JENIS LAYANAN</Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.label} variant="button">{data.order_courier_service}</Typography>
            </Grid>
          </Grid>
          <Divider />
          {data.order_weight > 0
            && (
              <div>
                <Grid container spacing={2} justify="space-between">
                  <Grid item>
                    <Typography className={classes.label} variant="button">BERAT (gr)</Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label} variant="button"><NumberFormat value={data.order_weight} isNumericString displayType="text" decimalScale={0} thousandSeparator="." decimalSeparator="," /></Typography>
                  </Grid>
                </Grid>
                <Divider />
              </div>
            )}
          <Grid container spacing={2} justify="space-between">
            <Grid item>
              <Typography className={classes.label} variant="button">NOMOR RESI</Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.label} variant="button">{data.order_shipping_code}</Typography>
            </Grid>
          </Grid>
          <Divider />
        </CardContent>
      </CardActionArea>
      <DialogLacakResi courierCode={data.order_courier_code} shippingCode={data.order_shipping_code} onClose={handleOnLacakClose} open={openLacak} />
    </Card>
  );
};

export default OrderInformasiKurir;
